<div [clrLoading]="loading">
    <div style="margin: 10px;">
        <b>Ports:</b>
        <clr-datagrid>
            <clr-dg-column>Summary</clr-dg-column>
            <clr-dg-column>Port</clr-dg-column>
            <clr-dg-column>Protocol</clr-dg-column>
            <clr-dg-column>Exchanged bytes</clr-dg-column>
            <clr-dg-column>Exchanged packets</clr-dg-column>

            <clr-dg-row *ngFor="let port of ports">
                <clr-dg-cell>
                    <a class="label label-blue" *ngIf="flowDetail.source">
                        {{ flowDetail.source.name }}
                        <span class="badge" *ngIf="port.direction === 1">{{port.label}}</span>
                    </a>
                    <a class="label label-blue" *ngIf="flowDetail.source === undefined">
                        {{ flowDetail.source }}
                    </a>

                    <span style="font-size: 16px; margin-right: 5px;" *ngIf="!bidirectional">&rarr;</span>
                    <span style="font-size: 16px; margin-right: 5px;" *ngIf="bidirectional">&harr;</span>

                    <a class="label label-blue" *ngIf="flowDetail.target">
                        {{ flowDetail.target.name }}
                        <span class="badge" *ngIf="port.direction === 0">{{port.label}}</span>
                    </a>
                    <a class="label label-blue" *ngIf="flowDetail.target === undefined">
                        {{ flowDetail.dst_ipaddr }}
                    </a>
                </clr-dg-cell>
                <clr-dg-cell><span class="label">{{port.label}}</span> <span class="label label-info" *ngFor="let proto of port.transport_protocols">{{proto.protoLabel}}</span></clr-dg-cell>
                <clr-dg-cell>
                    <a style="margin-right: 5px;" routerLink="/flows/protocol-analysis/protocols/{{protocol}}" [queryParams]="{}" routerLinkActive="active" *ngFor="let protocol of port.protocols">
                        <span class="label">{{protocol}}</span>
                    </a>
                </clr-dg-cell>
                <clr-dg-cell>{{ NetscopeUtils.formatBytes(port.exchanged_bytes) }} </clr-dg-cell>
                <clr-dg-cell>{{port.exchanged_packets | number}} packets </clr-dg-cell>
            </clr-dg-row>

            <clr-dg-footer>{{ports.length}} ports</clr-dg-footer>
        </clr-datagrid>
    </div>
</div>
